import PageProtectedLayout from "../../../../components/Page/PageProtectedLayout.jsx";
import FobTest from "./FobTest.jsx";
import { useTranslation } from '../../../../language';

export default function StoolWelcome() {

  const { t } = useTranslation();

return (

    <PageProtectedLayout

      headline={t('page_hl_cancer_prevention')}
      specify={t('page_sp_fob_stool_test')}

      >

      {/* Main Page Content */}
      <FobTest />

    </PageProtectedLayout>

  );
}
